import { createTheme, DEFAULT_THEME, SegmentedControl } from '@mantine/core';
import { produce } from 'immer';

const darkColor = '#3584e4';
const darkFactors = [
  [0.98, 0.25],
  [0.76, 0.43],
  [0.69, 0.45],
  [0.65, 0.45],
  [0.6, 0.65],
  [0.4, 0.75],
  [0.35, 0.75],
  [0.2, 0.55],
  [0.15, 0.5],
  [0.1, 0.5],
] as const;

const darkAccentColor = '#3584e4';
const darkAccentFactors = [
  [0.95, 0.45],
  [0.95, 0.45],
  [0.85, 0.45],
  [0.75, 0.45],
  [0.6, 0.55],
  [0.45, 0.55],
  [0.4, 0.55],
  [0.35, 0.45],
  [0.28, 0.45],
  [0.22, 0.45],
] as const;

export const theme = createTheme(
  produce(DEFAULT_THEME, (draft) => {
    draft.fontFamily = 'Mona Sans, sans-serif';
    draft.fontFamilyMonospace = 'Geist Mono, monospace';
    draft.autoContrast = true;
    draft.defaultRadius = 'xs';
    draft.cursorType = 'pointer';
    draft.primaryColor = 'blue';
    draft.primaryShade = { dark: 8, light: 6 };

    draft.components.SegmentedControl = SegmentedControl.extend({
      defaultProps: {
        color: 'blue',
      },
    });

    draft.colors.dark = Array.from(
      { length: darkFactors.length },
      (_, i) => `var(--theme-color-dark-${i})`,
    ) as (typeof draft.colors)[string];
    draft.colors['dark-accent'] = Array.from(
      { length: darkAccentFactors.length },
      (_, i) => `var(--theme-color-dark-accent-${i})`,
    ) as (typeof draft.colors)[string];

    draft.other = {
      theme: {
        backgroundDark: 'oklch(from var(--mantine-color-dark-9) calc(l * 0.6) c h)',
        darkHueOffset: 0,
        darkAccentHueOffset: 0,
        fontWidth: {
          md: 100,
          lg: 110,
          xl: 120,
          sm: 95,
          xs: 80,
        },
        backgroundVideoDisplay: 'none',
        color: {
          dark: darkFactors.map(
            ([lFactor, cFactor]) =>
              `oklch(from ${darkColor} ${lFactor} calc(c * ${cFactor}) calc(h + var(--theme-dark-hue-offset, 0)))`,
          ),
          darkAccent: darkAccentFactors.map(
            ([lFactor, cFactor]) =>
              `oklch(from ${darkAccentColor} ${lFactor} calc(c * ${cFactor}) calc(h + var(--theme-dark-accent-hue-offset, 0)))`,
          ),
        },
      },
    };
  }),
);
